import * as React from 'react';
import { Container, TituloSecao } from './styles';

import Grid from '../../componentes/Grid';
import { useParams } from 'react-router-dom';
import { useContext } from 'react';
import userContext from '../../Context/UserContext';

const Colecao: React.FC = () => {
  const {id, name}: any = useParams();
  const currentlyUser = useContext(userContext);
  const {Codcliente, Codempresacli} = currentlyUser.user;
 
  return (
    <Container>
      <TituloSecao>
        Coleção {decodeURIComponent(name)} 
      </TituloSecao>
      <Grid Titulo={"Coleção" + decodeURIComponent(name)} Colecao={id} Codcliente={Codcliente} Codempresacli={Codempresacli}/>
    </Container>
  )
};

export default Colecao;
